<template>
  <HubContainer id="kioskHub">

    <template v-if="atLeastCompanyAdmin && moduleActivated.kiosk">
      <HubSection large icon="icon/hub/settings.svg"
                  :title="$t('settings.title')"
                  :description="$t('settings.kiosk_description')"
                  :buttonAction="goToKiosk">
      </HubSection>

      <HubSection large icon="icon/hub/visual-configuration.svg"
                  :title="$t('style.title')"
                  :description="$t('style.kiosk_description')"
                  :buttonAction="goToKioskStyle">
      </HubSection>
    </template>

  </HubContainer>
</template>

<script>
  import HubSection from "@/components/HubSection";
  import HubContainer from "@/components/HubContainer";

  export default {
    name: "kioskHub",

    components: { HubSection, HubContainer },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "services.kiosk";
      this.$store.state.pageIcon = "/icon/nav/online-ordering.svg";

      if (this.$route.query.branch) {
        let branchModule = await this.$store.getters.getContextBranchActivatedModule;
        Object.assign(this.moduleActivated, branchModule);
      }

      if (this.$route.query.company) {
        let companyModule = await this.$store.getters.getContextCompanyActivatedModule;
        Object.assign(this.moduleActivated, companyModule);
      }
    },

    data() {
      return {
        moduleActivated: {
          onlineOrdering: false,
          kiosk: false,
          mobileApp: false,
          menuBoard: false,
          loyalty: false,
          thirdPartyLoyalty: false,
          aimsVouchers: false,
          onSiteOrdering: false,
          payAtTheTable: false,
          catering: false,
          dispatch: false,
          POS: false,
        }
      }
    },

    computed: {
      atLeastBranchAdmin() {
        return this.$store.getters.loggedUserHasBranchAdmin;
      },
      atLeastCompanyAdmin() {
        return this.$store.getters.loggedUserHasCompanyAdmin;
      },
      exactlyDistributor() {
        return this.$store.state.loggedUser.isDistributor;
      },
    },

    methods: {
      goToKiosk() {
        this.$router.push(this.$router.buildContext("/settings/services/kiosk"));
      },
      goToKioskStyle() {
        this.$router.push(this.$router.buildContext("/style/kiosk"));
      }
    }
  }
</script>